export default class SerialNumberGenerationError extends Error {
}
